/* Tela neutra enquanto o app resolve bootstrap/sessao — sem texto e sem marca (evita flash de conteudo). */
export function SplashScreen() {
    return (
        <main className="flex min-h-dvh items-center justify-center bg-app-background" aria-busy="true">
            <div className="size-8 animate-spin rounded-full border-2 border-brand/20 border-t-brand" />
        </main>
    )
}
